import ResetPasswordView from './ResetPassword.view';
import withNavBar from 'src/hocs/withNavBar.hoc';
import withHelmet from 'src/hocs/withHelmet';
import { compose } from 'ramda';
import withProps from 'src/hocs/withProps';
import {withCookies} from 'react-cookie'
import { t } from 'src/i18n';

const enhance = compose(
  withProps({ title: t('resetPassword.title') }),
  withHelmet,
  withCookies,
  withNavBar
);

export default enhance(ResetPasswordView);
